import type { PayloadAction } from '@reduxjs/toolkit'

import { createSlice } from '@reduxjs/toolkit'

import type {IIbcCameraEvent} from "../../types/ibc";

export interface IBCsState {
  isLoading: boolean;
  hasError: boolean;
  error: string;
  // paged list
  rows: IIbcCameraEvent[];
  page: number;
  rowsPerPage: number;
  totalCount: number | null;
  hasNext: boolean;
  currentEvent: IIbcCameraEvent;
  nextEvent: IIbcCameraEvent;
  previousEvent: IIbcCameraEvent;
  liveEvent: IIbcCameraEvent;
}

const initialState: IBCsState = {
  isLoading: false,
  hasError: false,
  error: '',
  rows: [],
  page: 0,
  rowsPerPage: 30,
  totalCount: null,
  hasNext: false,
  currentEvent: {} as IIbcCameraEvent,
  nextEvent: {} as IIbcCameraEvent,
  previousEvent: {} as IIbcCameraEvent,
  liveEvent: {} as IIbcCameraEvent,
};

type SetCameraEventsPagePayload = {
  rows: IIbcCameraEvent[];
  page: number;
  hasNext: boolean;
  totalCount?: number; // optional; omit if you don't compute it
};

export const cameraEventsSlice = createSlice({
  name: 'camera-events',
  initialState,
  reducers: {
    startLoading: (state) => {
      state.isLoading = true;
    },
    hasError: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.hasError = true;
      state.error = action.payload;
    },
    stopLoading: (state) => {
      state.isLoading = false;
    },
    setCurrentEvent(state, action: PayloadAction<IIbcCameraEvent>) {
      state.isLoading = false;
      state.currentEvent = action.payload;
    },
    setPreviousEvent(state, action: PayloadAction<IIbcCameraEvent>) {
      state.isLoading = false;
      state.previousEvent = action.payload;
    },
    setNextEvent(state, action: PayloadAction<IIbcCameraEvent>) {
      state.isLoading = false;
      state.nextEvent = action.payload;
    },
    setLiveEvent(state, action: PayloadAction<IIbcCameraEvent>) {
      state.isLoading = false;
      state.liveEvent = action.payload;
    },
    setCameraEventsPage(state, action: PayloadAction<SetCameraEventsPagePayload>) {
      state.rows = action.payload.rows;
      state.page = action.payload.page;
      state.hasNext = action.payload.hasNext;
      if (action.payload.totalCount !== undefined) {
        state.totalCount = action.payload.totalCount;
      }
      state.isLoading = false;
    },
    setCameraEventsTotalCount(state, action: PayloadAction<number>) {
      state.totalCount = action.payload;
    },
    setCameraEventsRowsPerPage(state, action: PayloadAction<number>) {
      state.rowsPerPage = action.payload;
    },
    clearCameraEvents: (state) => {
      state.rows = [];
      state.page = 0;
      state.hasNext = false;
      state.totalCount = null;
      state.isLoading = false;
    }
  },
})

// Action creators are generated for each case reducer function
export const {
  startLoading,
  stopLoading,
  hasError,
  setCameraEventsPage,
  setCameraEventsTotalCount,
  setCameraEventsRowsPerPage,
  clearCameraEvents,
  setCurrentEvent,
  setLiveEvent,
  setPreviousEvent,
  setNextEvent,
} = cameraEventsSlice.actions;

export default cameraEventsSlice.reducer
